import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { toast } from "sonner";
import { useT } from "@/lib/LanguageContext";
import { crmErrorMessage } from "../api/crmErrors";
import { crmHref } from "../paths";
import CrmButton from "../ui/CrmButton";
import { FOCUS_RING } from "../ui/classes";
import { CRM } from "../../../constants/testIds/crm";

/**
 * After an import or the first client: "Your Welcome and Reminder sequences are ready,
 * written for you. Review and switch on." — one click opens each pre-written sequence.
 * Owner only (the sequences are an owner screen); dismissible.
 */
export default function SetupBanner({ banner, onDismiss }) {
  const t = useT("crm");
  const tc = useT("common");
  const navigate = useNavigate();
  const open = (id) => navigate(crmHref(`/email/sequences/${encodeURIComponent(id)}`));
  const dismiss = async () => {
    try { await onDismiss(); } catch (e) { toast.error(crmErrorMessage(e, t, tc)); }
  };
  return (
    <div data-testid={CRM.setupBanner} className="relative rounded-2xl bg-eh-sage/20 px-5 py-4 pr-12">
      <p className="text-sm text-eh-ink">{t("setup.bannerText")}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {banner.welcome_sequence_id && (
          <CrmButton variant="outline" size="sm" onClick={() => open(banner.welcome_sequence_id)} data-testid={CRM.setupBannerWelcome}>
            {t("setup.bannerWelcome")}
          </CrmButton>
        )}
        {banner.reminders_sequence_id && (
          <CrmButton variant="outline" size="sm" onClick={() => open(banner.reminders_sequence_id)} data-testid={CRM.setupBannerReminders}>
            {t("setup.bannerReminders")}
          </CrmButton>
        )}
      </div>
      <button type="button" onClick={dismiss} aria-label={t("common.dismiss")} data-testid={CRM.setupBannerDismiss}
        className={`absolute right-4 top-4 rounded-full p-1 text-eh-ink hover:bg-eh-sage/30 ${FOCUS_RING}`}>
        <X size={16} aria-hidden="true" />
      </button>
    </div>
  );
}
